export default "__VITE_ASSET__$RcBUKzI__"